var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../../I18N";
import { advancedSort } from "../../utils/advancedSort";
import { NeedAuthorization } from "../../Auth";
import Attachment from "./Attachment";

import UploadSupportingFile from "./UploadSupportingFile";

export default class AttachmentsList extends Component {
  static arrangeFiles(files = []) {
    return advancedSort(files, { property: 'originalname' });
  }

  render() {
    const label = /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Supporting files"));



    const { parentId, parentSharedId, readOnly, storeKey, entity } = this.props;
    const forcedReadOnly = readOnly || Boolean(this.props.isTargetDoc);

    let uploadAttachmentButton = null;
    if (!this.props.isTargetDoc) {
      uploadAttachmentButton = /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0, /*#__PURE__*/
      _jsx("div", { className: "attachment-add" }, void 0, /*#__PURE__*/
      _jsx(UploadSupportingFile, { entitySharedId: this.props.parentSharedId, storeKey: storeKey })));



    }

    const attachments = AttachmentsList.arrangeFiles(this.props.attachments);
    return /*#__PURE__*/(
      _jsx("div", { className: "attachments-list-parent" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "attachments-list-header" }, void 0,
      attachments.length === 0 ? /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'], orWriteAccessTo: [entity] }, void 0,
      label) : /*#__PURE__*/


      React.createElement(React.Fragment, null, label),

      uploadAttachmentButton), /*#__PURE__*/

      _jsx("div", { className: "attachments-list" }, void 0,
      attachments.map((file, index) => /*#__PURE__*/
      _jsx(Attachment, {

        file: file,
        parentId: parentId,
        readOnly: forcedReadOnly,
        storeKey: storeKey,
        parentSharedId: parentSharedId,
        isSourceDocument: false,
        entity: entity }, index)))));





  }
}

AttachmentsList.defaultProps = {
  attachments: [],
  readOnly: false,
  isTargetDoc: false,
  parentId: null,
  parentSharedId: null,
  storeKey: '',
  entity: null
};











AttachmentsList.contextTypes = {
  confirm: PropTypes.func
};